import { useState } from 'react';
import { Typography, Tag, Space } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

import { StyledModal } from 'common/components';

import useWizard from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/context/useWizard';
import { selectRecommendationReason } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/context/selectors';

import { isGoToContactSales } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/utils/answers';

const { Paragraph, Link, Text } = Typography;

const SUB_ITEM_COLORS = {
  Beer: 'orange',
  Wine: 'red',
  Spirits: 'geekblue',
};

const ReasoningModal = () => {
  const { state } = useWizard();
  const [reasonModalVisible, setReasonModalVisible] = useState(false);

  const isContactStep = isGoToContactSales(state);

  const reasons = selectRecommendationReason(state);

  return (
    <>
      <div style={{ marginTop: 4, fontSize: 14 }}>
        <Link onClick={() => setReasonModalVisible(true)} underline>
          How did we come to this recommendation?
        </Link>
      </div>
      <StyledModal
        title='Recommendation Reasoning'
        visible={reasonModalVisible}
        onCancel={() => setReasonModalVisible(false)}
        footer={null}
        width={480}
      >
        <Paragraph style={{ marginBottom: 16 }} strong>
          {isContactStep
            ? 'Based on your answers, your products include:'
            : 'Based on your answers:'}
        </Paragraph>

        <Space direction='vertical' size={10} style={{ width: '100%' }}>
          {reasons.map((reason, index) => {
            const label = typeof reason === 'object' ? reason.label : reason;
            const subItems =
              typeof reason === 'object' ? (reason.subItems ?? []) : [];

            return (
              <div
                key={index}
                style={{
                  padding: '10px 14px',
                  borderRadius: 8,
                  background: '#fafafa',
                  border: '1px solid #f0f0f0',
                }}
              >
                <Space align='start'>
                  <CheckCircleFilled
                    style={{ color: '#52c41a', fontSize: 16, marginTop: 2 }}
                  />
                  <div>
                    <Text strong>{label}</Text>
                    {subItems.length > 0 && (
                      <div style={{ marginTop: 8 }}>
                        <Space size={6} wrap>
                          {subItems.map((sub, subIndex) => (
                            <Tag
                              key={subIndex}
                              color={SUB_ITEM_COLORS[sub] ?? 'blue'}
                            >
                              {sub}
                            </Tag>
                          ))}
                        </Space>
                      </div>
                    )}
                  </div>
                </Space>
              </div>
            );
          })}
        </Space>
      </StyledModal>
    </>
  );
};

export default ReasoningModal;
